import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { formatDate } from "../../helpers/formatDate";
import Pagination from "../../Components/Common/Pagination";
import { getPartnerRedemptions } from "../../actions/redemptions";

const Transactions = ({ launcherId }) => {
  const { rewardTypeMapping } = useSelector((state) => state.reward);
  const [transactions, setTransactions] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);

  useEffect(() => {
    if (launcherId) {
      getPartnerRedemptionsFunc();
    }
  }, [currentPage]);

  const getPartnerRedemptionsFunc = async () => {
    try {
      setIsLoading(true);
      const data = {
        pageSize: pageSize,
        pageOffset: currentPage - 1,
        launcherId: launcherId,
      };
      const res = await getPartnerRedemptions(data);

      setTransactions(res?.redemptions);
      setTotalPages(res?.totalPages);
      setTotalCount(res?.totalCount);

      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    } catch (e) {
      setIsLoading(false);
      console.log(e);
    }
  };

  return (
    <div className="px-4 pb-0 position-relative">
      {isLoading && (
        <div className="loader-overlay d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="table-responsive d-flex flex-column">
        <table className="table table-nowrap table-centered align-middle mb-0">
          <thead className="bg-light text-muted fs-14">
            <tr>
              <th>#</th>
              <th>Order Id</th>
              <th>Eligible Price</th>
              <th>Total Discount</th>
              <th>Sponsored Discount</th>
              <th>Reward Type</th>
              <th>Total Reward</th>
              <th>Sponsored Reward</th>
              <th>Order Status</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody className="fs-13">
            {transactions?.map((transaction, index) => {
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td>{index + 1}</td>
                    <td>#{transaction?.transactionRef}</td>
                    <td>
                      {transaction?.totalEligiblePrice &&
                      transaction?.totalEligiblePrice
                        ? `AED ${transaction?.totalEligiblePrice?.toFixed(2)}`
                        : "-"}
                    </td>
                    <td>
                      {transaction?.totalDiscount &&
                      transaction?.contributionAmount
                        ? `AED ${transaction?.totalDiscount?.toFixed(2)}`
                        : "-"}
                    </td>
                    <td className="fw-bold">
                      {transaction?.contributionAmount
                        ? `AED ${transaction?.contributionAmount?.toFixed(2)}`
                        : "-"}
                    </td>

                    <td>
                      {rewardTypeMapping?.[transaction?.rewardTypeId]?.name ||
                        "-"}
                    </td>
                    <td>
                      {transaction?.totalPoints
                        ? `${transaction?.totalPoints?.toFixed(2)} Pts`
                        : "-"}
                    </td>
                    <td>
                      {transaction?.contributionPoints
                        ? `${transaction?.contributionPoints?.toFixed(
                            2
                          )} Pts(${transaction?.contributionPointsInAmount?.toFixed(
                            2
                          )} AED)`
                        : "-"}
                    </td>
                    <td className="text-capitalize">{transaction?.status}</td>
                    <td>{formatDate(transaction?.createdAt, true)}</td>
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination
        totalPages={totalPages}
        totalItems={totalCount}
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        itemsPerPage={pageSize}
      />
    </div>
  );
};

export default Transactions;
